import templateUrl from './filter-field.tpl.html';

import './types/filter-type-boolean';
import './types/filter-type-date';
import './types/filter-type-datetime';
import './types/filter-type-datetimeexact';
import './types/filter-type-integer';
import './types/filter-type-number';
import './types/filter-type-select';
import './types/filter-type-string';
import './types/filter-type-json';

angular
    .module('festzelt-os.components')
    .component('filterField', {
        bindings: {
            store: '<',
            col: '<',
        },
        controller: function () {
            this.$onInit = () => {
                switch (this.col.type) {
                    case 'image':
                    case 'file':
                        this.filterType = 'string';
                        break;
                    default:
                        this.filterType = this.col.type;
                }
            }
        },
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/components/state-manager/filter-field/filter-field.js